import {ClientSanityLoggedOut} from './endpoints/ClientSanityLoggedOut'
import {ContactPartnerships} from './endpoints/ContactPartnerships'
import {ContactSales} from './endpoints/ContactSales'
import {ContactTreasury} from './endpoints/ContactTreasury'
import {FEMReferralAttribution} from './endpoints/FEMReferralAttribution'
import {Geolocate} from './endpoints/Geolocate'
import {HelpCenterGetArticles} from './endpoints/HelpCenterGetArticles'
import {InvestorDatabaseGetPublicInvestorItems} from './endpoints/InvestorDatabaseGetPublicInvestorItems'
import {ListInterestRates} from './endpoints/ListInterestRates'
import {NewsletterSubscribe} from './endpoints/NewsletterSubscribe'

export const api = {
  listInterestRates: new ListInterestRates(),
  newsletterSubscribe: new NewsletterSubscribe(),
  contactPartnerships: new ContactPartnerships(),
  contactSales: new ContactSales(),
  contactTreasury: new ContactTreasury(),
  geolocate: new Geolocate(),
  clientSanityLoggedOut: new ClientSanityLoggedOut(),
  femReferralAttribution: new FEMReferralAttribution(),
  investorDatabaseGetPublicInvestorItems:
    new InvestorDatabaseGetPublicInvestorItems(),
  helpCenterGetArticles: new HelpCenterGetArticles(),
}
